import React, { useState, useEffect } from 'react';
import { Card, Table, Row, Col, InputGroup, FormControl, Container } from 'react-bootstrap';
import axios from 'axios';

const OptionDataDisplay = () => {
    const styles = {
        card: {
            marginTop: '20px',
            backgroundColor: '#ffffff',
            border: '1px solid #ddd',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        },
        table: { fontSize: '14px' },
        header: { backgroundColor: '#f8f9fa', fontWeight: 'bold' },
        noData: { textAlign: 'center', padding: '20px', color: '#6c757d' },
        placeholder: { textAlign: 'center', padding: '40px', coloe: '#6c757d', fontSize: '18px' },
    };

    const [strikeData, setStrikeData] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStrikeData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/indices`);
                const transformedData = response.data.reduce(
                    (acc, { name, strikeData }) => ({
                        ...acc,
                        [name]: {
                            ce: Array.isArray(strikeData?.ce) ? strikeData.ce : [],
                            pe: Array.isArray(strikeData?.pe) ? strikeData.pe : [],
                        },
                    }),
                    {}
                );
                setStrikeData(transformedData);
                setError(null);
            } catch (error) {
                console.error('Error fetching strike data:', error);
                setError(error.response?.data?.message || 'Failed to fetch strike data');
            }
        };
        fetchStrikeData();
    }, []);

    const renderTableRows = (data) => {
        if (!data || data.length === 0) {
            return (
                <tr>
                    <td colSpan="4" style={styles.noData}>
                        No data available
                    </td>
                </tr>
            );
        }
        return data.map((item, index) => (
            <tr key={index}>
                <td>{item.token || 'N/A'}</td>
                <td>{item.symbol || 'N/A'}</td>
                <td>{item.strike || 'N/A'}</td>
                <td>{item.expiry || 'N/A'}</td>
            </tr>
        ));
    };

    const indices = strikeData && typeof strikeData === 'object' ? Object.keys(strikeData) : [];
    const ceArray = selectedIndex && strikeData ? strikeData[selectedIndex].ce : [];
    const peArray = selectedIndex && strikeData ? strikeData[selectedIndex].pe : [];

    if (error) {
        return (
            <Row>
                <Col>
                    <div style={styles.placeholder}>Error: {error}</div>
                </Col>
            </Row>
        );
    }

    if (!strikeData) {
        return (
            <Row>
                <Col>
                    <div style={styles.placeholder}>Loading strike data...</div>
                </Col>
            </Row>
        );
    }

  return (
    <Container className='bg-white shadow p-4 mt-4'>
        <Row className=''>
            <Row className='mb-3'>
                <Col md={4}>
                    <h5>Select Index to Display Options</h5>
                    <InputGroup>
                        <InputGroup.Text>Index</InputGroup.Text>
                        <FormControl
                            as="select"
                            value={selectedIndex}
                            onChange={(e) => setSelectedIndex(e.target.value)}
                        >
                            <option value="">Select an Index</option>
                            {indices.map((idx) => (
                                <option key={idx} value={idx}>
                                    {idx}
                                </option>
                            ))}
                        </FormControl>
                    </InputGroup>
                </Col>
            </Row>
            {selectedIndex ? (
                <>
                <Col md={6}>
                    <Card style={styles.card}>
                        <Card.Header style={styles.header}>{selectedIndex} Call Options (CE)</Card.Header>
                        <Card.Body>
                            <Table striped bordered hover size='sm' style={styles.table}>
                                <thead>
                                    <tr>
                                        <th>Token</th>
                                        <th>Symbol</th>
                                        <th>Strike</th>
                                        <th>Expiry</th>
                                    </tr>
                                </thead>
                                <tbody>{renderTableRows(ceArray)}</tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card style={styles.card}>
                        <Card.Header style={styles.header}>{selectedIndex} PUT Options (PE)</Card.Header>
                        <Card.Body>
                            <Table striped bordered hover size='sm' style={styles.table}>
                                <thead>
                                    <tr>
                                        <th>Token</th>
                                        <th>Symbol</th>
                                        <th>Strike</th>
                                        <th>Expiry</th>
                                    </tr>
                                </thead>
                                <tbody>{renderTableRows(peArray)}</tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
                </>
            ) : (
                <Col>
                    <div style={styles.placeholder}>
                        {indices.length === 0
                            ? 'No indices available'
                            : 'Please select an index from the dropdown to view CE and PE data.'}
                    </div>
                </Col>
            )}
        </Row>
    </Container>
  );
};

export default OptionDataDisplay;